import classNames from 'classnames'
import { setMetricsTypes } from 'features/report/reportAddSlice'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NoneAnchor from 'components/NoneAnchor'
import { CAMPAIGN, getDomainText } from 'features/report/common/DomainText'
import CheckBox from 'components/form/CheckBox'
import HelpTooltip from '../../../components/tooltip/HelpTooltip'
import { CampaignTypes } from '../../Codes'
import useOutsideClick from '../../../utils/hooks/useOutsideClick'

const MetricTypeFilter = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const ref = useOutsideClick(() => setVisible(false))
  const { domain, metricsTypes, campaignType } = useSelector(
    state => state.report.reportAdd.formValues
  )
  const domainText = getDomainText(domain)
  return (
    <div ref={ref} className="single_wrap">
      <div
        className={classNames('opt_select opt_limited', {
          opt_open: visible,
        })}>
        <div className="screen_out">데이터종류 선택상자</div>
        <span className="screen_out">선택내용 : </span>
        <NoneAnchor
          className="link_selected"
          onClick={() => setVisible(prev => !prev)}>
          {metricsTypes.length === 1 && metricsTypes[0] === 'default'
            ? '열 : 기본 지표'
            : '열 : 사용자 설정'}
        </NoneAnchor>
        <span className="ico_arr" />
        <div className="screen_out">선택옵션</div>
        <div className="opt_list">
          <ul className="list_opt">
            <li
              className={classNames({
                on: metricsTypes.includes('defaults'),
              })}>
              <CheckBox
                label="기본 지표"
                tiaraAction={`보고서_${domainText}_열:사용자설정_기본지표_클릭`}
                checked={metricsTypes.includes('default')}
                onChange={() => dispatch(setMetricsTypes('defaults'))}
              />
            </li>
            <li
              className={classNames({
                on: metricsTypes.includes('additional'),
              })}>
              <CheckBox
                label="추가 지표"
                tiaraAction={`보고서_${domainText}_열:사용자설정_추가지표_클릭`}
                checked={metricsTypes.includes('additional')}
                onChange={() => dispatch(setMetricsTypes('additional'))}
              />
            </li>
            <li
              className={classNames({
                on: metricsTypes.includes('pixelAndSdk'),
              })}>
              <CheckBox
                label="픽셀&SDK 전환 지표"
                tiaraAction={`보고서_${domainText}_열:사용자설정_픽셀&SDK전환지표_클릭`}
                checked={metricsTypes.includes('pixelAndSdk')}
                onChange={() => dispatch(setMetricsTypes('pixelAndSdk'))}
              />
            </li>
            {(domain === CAMPAIGN ||
              campaignType === CampaignTypes.TALK_CHANNEL) && (
              <li
                className={classNames({
                  on: metricsTypes.includes('kakaoFriend'),
                })}>
                <CheckBox
                  label={
                    <>
                      카카오친구 지표
                      <HelpTooltip>
                        톡채널검색만 제공되는 지표입니다.
                      </HelpTooltip>
                    </>
                  }
                  tiaraAction={`보고서_${domainText}_열:사용자설정_카카오친구지표_클릭`}
                  checked={metricsTypes.includes('kakaoFriend')}
                  onChange={() => dispatch(setMetricsTypes('kakaoFriend'))}
                />
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default MetricTypeFilter
